import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { isAdminUser } from 'utils/common';

export const AdminRoute = ({ component: Component, permission, redirectUrl, ...rest }) => (
  <Route
    {...rest}
    exact
    render={(props) => (isAdminUser() ? <Component {...props} /> : <Redirect to={redirectUrl || '/'} />)}
  />
);
